import { IconSelector } from "@tabler/icons-react";
import type * as React from "react";

import { cn } from "../lib/utils";

/** The browser's own select, styled: the right control on a phone, and for a short fixed list. */
function NativeSelect({
	className,
	size = "default",
	...props
}: Omit<React.ComponentProps<"select">, "size"> & { size?: "sm" | "default" }) {
	return (
		<div
			data-slot="native-select-wrapper"
			className="group/native-select relative w-fit has-[select:disabled]:opacity-50"
		>
			<select
				data-slot="native-select"
				data-size={size}
				className={cn(
					"h-9 w-full min-w-0 appearance-none rounded-4xl border border-input bg-input/30 py-1 pr-8 pl-3 text-sm transition-colors outline-none select-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 data-[size=sm]:h-8 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&>option]:bg-popover [&>option]:text-popover-foreground",
					className,
				)}
				{...props}
			/>
			<IconSelector
				className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground select-none"
				aria-hidden
			/>
		</div>
	);
}

function NativeSelectOption({ ...props }: React.ComponentProps<"option">) {
	return <option data-slot="native-select-option" {...props} />;
}

export { NativeSelect, NativeSelectOption };
